import cn from 'classnames';
import { lazy, memo, Suspense, useMemo } from 'react';

const CategoryIcon = lazy(() => import('./CategoryIcon'));

interface SvgIconProps {
	type: 'sport' | 'category';
	iconId: string | number;
	id?: string;
	className?: string;
}

export const SvgIcon = memo(({ type, iconId, id, className }: SvgIconProps) => {
	const props = useMemo(
		() => ({
			height: 14,
			width: 14,
			id,
			className: cn(className),
		}),
		[id, className],
	);

	function renderFallback() {
		return (
			<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
				<circle cx="16" cy="16" r="16" fill="#699696" opacity="0.4" />
			</svg>
		);
	}

	return (
		<Suspense fallback={renderFallback()}>
			<CategoryIcon props={props} type={type} iconId={iconId?.toString()} />
		</Suspense>
	);
});

SvgIcon.displayName = 'SvgIcon';
